/* eslint-disable camelcase */
import Vue from 'vue';
import hljs from 'highlight.js';
Vue.use(hljs.vuePlugin);
import 'highlight.js/styles/night-owl.css';
import jsonSyntaxHighlighter from '../utils/jsonSyntaxHighlighter';
import Card from 'src/components/Card/Card';
import copyContentFromElementByIdIntoClipboard from 'src/utils/clipboard/copyContentFromElementByIdIntoClipboard';
import getContentFromElementById from 'src/utils/clipboard/getContentFromElementById';
export default Vue.extend({
    components: { Card },
    props: {
        code: { type: String, default: '' },
        codeLanguage: { type: String, default: 'JSON' },
        callBackForSaving: { type: Function },
        title: { type: String, default: 'Code viewer' },
        visible: { type: Boolean, default: false }
    },
    data() {
        return {
            code__ls: '',
            codeLanguage__ls: 'JSONB',
            visible__ls: false,
            callBackForSaving__ls: undefined,
            title__ls: 'Code viewer'
        };
    },
    computed: {
        highlightedJSON() {
            const res = jsonSyntaxHighlighter(this.code);
            return res;
        }
    },
    watch: {
        code: {
            handler(newVal) { this.code__ls = newVal; },
            immediate: true
        },
        codeLanguage: {
            handler(newVal) { this.codeLanguage__ls = newVal; },
            immediate: true
        },
        visible: {
            handler(newVal) { this.visible__ls = newVal; },
            immediate: true
        },
        callBackForSaving: {
            handler(newVal) { this.callBackForSaving__ls = newVal; },
            immediate: true
        },
        title: {
            handler(newVal) { this.title__ls = newVal; },
            immediate: true
        },
        visible__ls(newVal) {
            if (!newVal)
                this.$emit('close');
        }
    },
    methods: {
        copy() { copyContentFromElementByIdIntoClipboard('area'); },
        save() {
            const text = getContentFromElementById('area');
            if (this.callBackForSaving && text) {
                const saveCode = this.codeLanguage === 'JSON' ? JSON.parse(text) : text;
                this.callBackForSaving(saveCode);
            }
            this.visible__ls = false;
        },
        openDialog(params) {
            const { code, codeLanguage, callBackForSaving, title } = params;
            this.visible__ls = true;
            if (callBackForSaving)
                this.callBackForSaving__ls = callBackForSaving;
            if (title)
                this.title__ls = title;
            if (typeof code === 'string') {
                this.code__ls = code;
            }
            else {
                this.code__ls = JSON.stringify(code, null, 2);
            }
            this.codeLanguage__ls = codeLanguage || 'JSON';
        }
    }
});
